import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "seq-tabs seq-dashboard-page-tabs mb-4" }
const _hoisted_2 = { class: "seq-dashboard-page-tabs__links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_DashboardMoveControls = _resolveComponent("DashboardMoveControls")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: tab.to,
          to: tab.to,
          class: "seq-tabs__link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tab.label), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    _createVNode(_component_DashboardMoveControls, { class: "seq-dashboard-page-tabs__move" })
  ]))
}